import { Feature } from '@ardoq/api-types';
import { PathRouteContent } from './routeNode';
import { UnauthorizedAccessPageProps } from '@ardoq/manage-resource-permissions';

const defaultUnauthorizedAccess: UnauthorizedAccessPageProps = {
  pageName: 'Feature',
  message:
    'This feature is not available for your organization. Please contact your admin if you need access to this feature.',
};

const defaultDisabledFeature: UnauthorizedAccessPageProps = {
  pageName: 'Feature',
  title: 'This feature is turned off.',
  message:
    'This feature has been turned off for your organization. Please contact your admin if you need access to this feature.',
  link: null,
};

export const featureFlagBoundary =
  (
    requiredFeatures: Feature[],
    unauthorizedAccess: UnauthorizedAccessPageProps = defaultUnauthorizedAccess
  ) =>
  async (): PathRouteContent =>
    (
      await import('./DeclarativeFeatureFlagBoundaryPage')
    ).buildFeatureFlagBoundary(requiredFeatures, unauthorizedAccess);

export const disabledByFeatureFlagBoundary =
  (
    disablingFeatures: Feature[],
    unauthorizedAccess: UnauthorizedAccessPageProps = {}
  ) =>
  async (): PathRouteContent =>
    (
      await import('./DeclarativeFeatureFlagBoundaryPage')
    ).buildDisabledByFeatureFlagBoundary(disablingFeatures, {
      ...defaultDisabledFeature,
      ...unauthorizedAccess,
    });
